import { render, staticRenderFns } from "./GoodsQrCode.vue?vue&type=template&id=df47a7c2&scoped=true&"
import script from "./GoodsQrCode.vue?vue&type=script&lang=js&"
export * from "./GoodsQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df47a7c2",
  null
  
)

export default component.exports